import { ModuleId, SectionId } from '@nirvana/shared/dtos/types/policies/common';
import { DataLoadedStatus, PolicyAppState } from '../../types';
import { createAction, PayloadAction } from '@reduxjs/toolkit';
import { PoliciesReduxActions } from '../../actions';

// SELECTORS
export const getIsGeneralDetailsValidationLoaded = (state: PolicyAppState): DataLoadedStatus =>
  state.modules[ModuleId.POLICY_SETTINGS]?.sections[SectionId.DETAILS].additionalInfo.policyValidityLoaded ??
  DataLoadedStatus.NOT_LOADED;
export const getIsGeneralSecurityTelemetryValidationLoaded = (state: PolicyAppState): DataLoadedStatus =>
  state.modules[ModuleId.GENERAL]?.sections[SectionId.SECURITY_TELEMETRY].additionalInfo.serverUrlValidityLoaded ??
  DataLoadedStatus.NOT_LOADED;

// ACTIONS
export const setValidationLoadedForGeneralDetails = createAction<DataLoadedStatus>(
  PoliciesReduxActions.SET_POLICY_VALIDITY_LOADED_FOR_GENERAL_DETAILS
);
export const setValidationLoadedForGeneralSecurityTelemetry = createAction<DataLoadedStatus>(
  PoliciesReduxActions.SET_SERVER_URL_LOADED_FOR_GENERAL_SECURITY_TELEMTRY
);
export const setValidationLoadedForGeneralDetailsActionHandler = (
  state: PolicyAppState,
  action: PayloadAction<DataLoadedStatus>
): void => {
  const module = state.modules[ModuleId.POLICY_SETTINGS];

  if (!module) {
    return;
  }

  module.sections[SectionId.DETAILS].additionalInfo.policyValidityLoaded = action.payload;
};

export const setValidationLoadedForGeneralSecurityTelemetryActionHandler = (
  state: PolicyAppState,
  action: PayloadAction<DataLoadedStatus>
): void => {
  const module = state.modules[ModuleId.GENERAL];

  if (!module) {
    return;
  }

  module.sections[SectionId.SECURITY_TELEMETRY].additionalInfo.serverUrlValidityLoaded = action.payload;
};
